(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("c-variant-picker")) {
  customElements.define(
    "c-variant-picker",
    class ComponentVariantPicker extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // qty var
        this.qtyInput = this.querySelector('.js-variant-picker__form-qty-input');
        this.qtyButtonPlus = this.querySelector('.js-variant-picker__form-qty-button--plus');
        this.qtyButtonMinus = this.querySelector('.js-variant-picker__form-qty-button--minus');
        
        this.qtyButtonPlus?.addEventListener('click', this.qtyButtonPlusClickHandler);
        this.qtyButtonMinus?.addEventListener('click', this.qtyButtonMinusClickHandler);
        this.qtyInput?.addEventListener('change', this.qtyInputChangeHandler);

        this.form = this.querySelector(".js-variant-picker__form");

        this.submitBtn = this.querySelector(".js-variant-picker__form-submit");

        this.form.addEventListener("change", this.formHandler);

        this.form.addEventListener("submit", this.onSubmitHandler);
      }

      disconnectedCallback() {
        this.qtyButtonPlus?.removeEventListener('click', this.qtyButtonPlusClickHandler);
        this.qtyButtonMinus?.removeEventListener('click', this.qtyButtonMinusClickHandler);
        this.qtyInput?.removeEventListener('change', this.qtyInputChangeHandler);
        this.form.removeEventListener("change", this.formHandler);
        this.form.removeEventListener("submit", this.onSubmitHandler);
      }

      onSubmitHandler = (evt) => {
        evt.preventDefault();  
  
        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        };
  
        let formData = new FormData(this.form);
  
        if(this?.getSectionsToRender){
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
        }
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        this.submitBtn.setAttribute("disabled", "")
  
        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            window.PubSub.publish('cart-modal:open');
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitBtn.removeAttribute("disabled")
          });
      }

      formHandler = (event) => {
        if(event.target.getAttribute("name") === "quantity") return
        console.log(event.target)
        // this.style = "opacity: 0.5; pointer-events: none;"

        window.PubSub.publish("variant-change", [event.target.value]);
      }

      qtyInputChangeHandler = () => {

        if (parseInt(this.qtyInput.value) > parseInt(this.qtyInput.max)) {
          this.qtyInput.value = this.qtyInput.max
        }
  
        if (parseInt(this.qtyInput.value) < parseInt(this.qtyInput.min)) {
          this.qtyInput.value = this.qtyInput.min
        }
  
        if (parseInt(this.qtyInput.value) === parseInt(this.qtyInput.max)) {
          this.qtyButtonPlus.classList.add('c-variant-picker__form-qty-button--disabled')
        } else {
          this.qtyButtonPlus.classList.remove('c-variant-picker__form-qty-button--disabled')
        }
  
        if (parseInt(this.qtyInput.value) === parseInt(this.qtyInput.min)) {
          this.qtyButtonMinus.classList.add('c-variant-picker__form-qty-button--disabled')
        } else {
          this.qtyButtonMinus.classList.remove('c-variant-picker__form-qty-button--disabled')
        }
  
      }

      qtyButtonPlusClickHandler = () => {
        this.qtyInput.value = parseInt(this.qtyInput.value) + 1
  
        this.qtyInput.dispatchEvent(new Event('change'))
      }
  
      qtyButtonMinusClickHandler = () => {
        this.qtyInput.value = parseInt(this.qtyInput.value) - 1
  
        this.qtyInput.dispatchEvent(new Event('change'))
      }
    }
  );
}



},{}]},{},[1])

